import { render, staticRenderFns } from "./buyerBox.vue?vue&type=template&id=469beda2&scoped=true&"
import script from "./buyerBox.vue?vue&type=script&lang=js&"
export * from "./buyerBox.vue?vue&type=script&lang=js&"
import style0 from "./buyerBox.vue?vue&type=style&index=0&id=469beda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469beda2",
  null
  
)

export default component.exports